import { useMutation } from "@apollo/client";
import { errorsHandler } from "~/transformers";

import { HANDLE_IMPORT_UPLOAD_ID_MUTATION } from "~/api";

export const sendImportUploadId = () => {
  const [handleImportUploadId, { error = {}, loading }] = useMutation(
    HANDLE_IMPORT_UPLOAD_ID_MUTATION,
  );
  return {
    mutation: (input) =>
      new Promise((resolve, reject) => {
        return handleImportUploadId({
          variables: {
            input,
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
    loading,
    error,
  };
};
